import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";

const initialState = {
  devicesInRangePerDevice: new Map<string, Set<string>>(),
  loading: true,
};

export const ProximitySampleStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    init(samples: Samples.AssetSample<Samples.ProximitySample>[]) {
      const partitionedSamples = new Map<string, Set<Samples.Sample<Samples.ProximitySample>>>();
      for (const sample of samples) {
        const key = sample.sample.instant + sample.sample.deviceId;
        const current = partitionedSamples.get(key) || new Set<Samples.Sample<Samples.ProximitySample>>();
        current.add(sample.sample);
        partitionedSamples.set(key, current);
      }

      const result = new Map<string, Set<string>>();
      for (const samples of partitionedSamples.values()) {
        const deviceIds = new Set<string>();
        samples.forEach(sample => {
          deviceIds.add(sample.deviceId);
          deviceIds.add(sample.value.serial);
        });

        for (const deviceId of deviceIds.values()) {
          const current = result.get(deviceId) || new Set<string>();
          for (const otherDeviceId of deviceIds.values()) {
            if (otherDeviceId !== deviceId) {
              current.add(otherDeviceId);
            }
          }
          result.set(deviceId, current);
        }
      }

      patchState(store, { devicesInRangePerDevice: result, loading: false });
    }
  })
));
